<template><div :id="field.name" class="FieldInputNew">

    <template v-if="INPUT_TEXT === field.type">
      <div class="input-container">
        <template v-if="!field.usemask">
            <input
            type="text"
            class="focusWhenEmpty"
            :class="{ red: validLogic.red }"
            :placeholder="field.placeholder"
            :value="locval"
            @input="set_locval_delay($event.target.value)"
            @blur="set_locval($event.target.value)"
            >
        </template>
        <template v-else>
            
            <imaskInput
                ref="imaskComp"
                class="focusWhenEmpty"
                :placeholder="field.placeholder"
                :class="{ red: validLogic.red }"
                :value="locval"
                :mask="field.usemask.mask"
                :lazy="field.usemask.lazy"
                :overwrite="field.usemask.overwrite"
                :unmask="true"
                @accept="set_locval_delay"
                @blur="set_locval_imaskComp"
              />

        </template>

        <label>{{ title }}</label>
        <span v-if="validLogic.hasError" class="error">{{validLogic.error}}</span>
      </div>
    </template>

    
    <template v-else-if="[INPUT_SELECT, INPUT_SELECTSEARCH].includes( field.type)">
        <div class="custom-new-select">
            <MySelect tabindex="-1" class="focusWhenEmpty"
                :class="{ red: validLogic.red }"
                :label="title"
                :list="options"
                :choosed="field.val"
                :onlyone="true"
                @input="select"
            >
            </MySelect>
            <span v-if="validLogic.hasError" class="error">{{validLogic.error}}</span>
        </div>
    </template>

    <template v-else-if="INPUT_SELECTCHIPS === field.type">
        <div class="custom-radio-container focusWhenEmpty" tabindex="-1">
            <label class="custom-radio-container__label" :class="{ red: validLogic.red }">{{ title }}</label>
            <div class="custom-radio-container__options">
                <span 
                    v-for="option in options" 
                    tabindex="0"
                    class="custom-radio-container__option" 
                    @click="set_field(option.id)"
                    :class="{selected: selected(option)}">{{option.name}}
                </span>
            </div>
            <span v-if="validLogic.hasError" class="error">{{validLogic.error}}</span>
        </div>
    </template>


    <template v-else-if="INPUT_DATE === field.type">
      <div style="position: relative" class="datepick-container">
        <date-pick tabindex="-1"
            class="datepick-container__input-container focusWhenEmpty"
            :class="{red:validLogic.red}"
            v-model="date"
            :format="format"
            :nextMonthCaption="nextMonthCaption"
            :prevMonthCaption="prevMonthCaption"
            :setTimeCaption="setTimeCaption"
            :weekdays="weekdays"
            :months="months"
            :selectableYearRange="99"
        >
            <template v-slot:default="{toggle, inputValue}">
                <imaskInput
                    ref="imaskComp"
                    :value="locval"
                    :mask="Date"
                    :lazy="isMaskLazy"
                    pattern="d{.}`m{.}`Y"
                    :unmask="true"
                    :overwrite="true"
                    @accept="set_locval_delay"
                    @focus="toggle"
                    @blur="set_locval_imaskComp"
                  />
                  <span
                    class="datepick-container__label"
                    :class="{ _active: isLabelActive }"
                    >
                    {{ title }}
                </span>
            </template>
        </date-pick>
        <span v-if="validLogic.hasError" class="error" >{{validLogic.error}}</span>
      </div>

    </template>
    
    <template v-else-if="INPUT_TEXTAREA === field.type">
      <textarea tabindex="-1"
      class="custom-textarea focusWhenEmpty"
      :class="{red:validLogic.red}"
      :placeholder="field.placeholder" v-model="textarea" @change="text_change($event.target.value)"></textarea>
      <span class="error" v-if="validLogic.hasError">{{validLogic.error}}</span>
    </template>
  

</div></template>

<style lang="scss" src="./FieldInputNew.scss"></style>

<script setup>
import {ref, computed, toRef, unref, onBeforeUnmount, watch} from 'vue'
import useTouristStore from '@/tourist/tourist-store.js'
import {INPUT_TEXT, INPUT_SELECT, INPUT_SELECTSEARCH, INPUT_SELECTCHIPS,  INPUT_DATE, INPUT_TEXTAREA } from '@/tourist/tourist-store.js'
import DatePick from 'vue-date-pick'
import 'vue-date-pick/src/vueDatePick.scss'
import vDown from '@/assets/vicons/chevron-down.vue'
import MyMulti from '@/comp/MyMulti/MyMulti.vue'
import MySelect from '@/comp/MySelect/MySelect.vue'
import { IMaskComponent as imaskInput } from 'vue-imask'
import {debounce} from '@/util.js'

const tstore=useTouristStore()

const props = defineProps({
    field: Object,
    vest: Object,
    title: String,
    touched: { type: Boolean, default: false},
})
const emits = defineEmits( ['input'] )
const field = toRef(props, 'field') // только для template для краткости


/***********************************
 * для всех INPUT
 */
const locval = ref('')

watch( 
    () => props.field.val, 
    (newval, oldval) => {
        if (newval!==oldval) {
            locval.value = newval
        }
    }, 
    {immediate: true}
)

const set_field = (value) => {
    tstore.set_field( props.field.sid, props.field.name, value )
    emits('input')
}

const set_deb = () => {
    set_field( unref(locval) )
}
const deb = debounce( set_deb, 1000 )

const set_locval = (value) => {
    locval.value = value
    set_field( value )
}

const set_locval_delay = value => {
    locval.value = value
    deb()
}

const imaskComp = ref(null)
const set_locval_imaskComp = () => {
    const comp = unref(imaskComp)
    if (comp) {
      set_locval(comp.value)
    }
}

const validLogic = computed( () => { // не проверенные светится не будут
    let rec =  props.vest.tests[ props.field.name ]
    let red = false
    let hasError = false
    let error = ''

    if (rec) {// если нет rec - значит поле вообще не проверяется
        if (props.touched || ''!==props.field.val) {// проверяем только touched либо непустые
            red = !rec.valid
            hasError = rec.errors.length > 0
            error = hasError ? rec.errors[0] : ''
        }
    }

    return {
        red, hasError, error
    }
}) 


/***********************************
 * INPUT_TEXTAREA INPUT_TEXT
 */
const textarea = computed({
    get() {
        return props.field.val
    },
    set(value) {
    }
})
const text_change = set_field


/***********************************
 * INPUT_SELECT INPUT_SELECTCHIPS INPUT_SELECTSEARCH
 */
const options = computed( () => {
    return props.field.options
})
const select = set_field
const selected = ({id}) => {
    return id === props.field.val
}


/***********************************
 * INPUT_DATE
 */
const format = 'DD.MM.YYYY'
const date = computed({
    get() {
        return props.field.val
    },
    set(value) {
        set_field( value )
    }
})


const nextMonthCaption='Следующий месяц'
const prevMonthCaption='Предыдущий месяц'
const setTimeCaption='Время';
const weekdays = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
const months=[
    'Январь', 'Февраль', 'Март', 'Апрель',
    'Май', 'Июнь', 'Июль', 'Август',
    'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
]

const isMaskLazy = ref(true)
const isFocused = ref(false)

const onDateFocus = (toggle) => {// TODO: использовать 
  isMaskLazy.value = false
  isFocused.value = true
  toggle()
}

const onDateBlur = () => {// TODO: использовать 
  isFocused.value = false

  if (!props.field.val) {
    isMaskLazy.value = true
  }
}

const isLabelActive = computed(() => {
  return isFocused.value || !!props.field.val
})

</script>
